var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4537 0.482081L7.37027 7.85468L3.58682 3.91679C3.43462 3.75276 3.25255 3.62193 3.05124 3.53193C2.84994 3.44192 2.63342 3.39454 2.41434 3.39256C2.19525 3.39058 1.97798 3.43404 1.7752 3.52039C1.57242 3.60674 1.3882 3.73425 1.23327 3.8955C1.07835 4.05675 0.955833 4.24849 0.872869 4.45955C0.789906 4.67061 0.748159 4.89675 0.750062 5.12477C0.751966 5.3528 0.797483 5.57816 0.883958 5.78768C0.970433 5.9972 1.09613 6.1867 1.25373 6.34512L6.20373 11.4972C6.51315 11.8191 6.93275 12 7.37027 12C7.8078 12 8.2274 11.8191 8.53682 11.4972L16.7868 2.91042C17.0874 2.58652 17.2537 2.15271 17.2499 1.70243C17.2462 1.25215 17.0726 0.821412 16.7667 0.503001C16.4608 0.18459 16.047 0.00397777 15.6143 6.49205e-05C15.1817 -0.00384793 14.7649 0.169252 14.4537 0.482081Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark.7cf77bd5c5473e1b06307fa032abb795.svg";